import { render, staticRenderFns } from "./PremiaDlaZamowienia.html?vue&type=template&id=2cd75f2f&scoped=true&external"
import script from "./PremiaDlaZamowienia.js?vue&type=script&lang=js&external"
export * from "./PremiaDlaZamowienia.js?vue&type=script&lang=js&external"
import style0 from "./PremiaDlaZamowienia.css?vue&type=style&index=0&id=2cd75f2f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd75f2f",
  null
  
)

export default component.exports